export type SortOrder = 'asc' | 'desc';

export function sortBy<T extends {}>(
  data: T[],
  selector: ((item: T) => any) | keyof T,
  order: SortOrder,
  groupBy?: keyof T,
): T[] {
  const orderSign = order === 'asc' ? 1 : -1;
  return [...data].sort((a, b) => {
    if (groupBy && a[groupBy] != b[groupBy]) {
      return (a[groupBy] > b[groupBy] ? 1 : -1) * orderSign;
    }
    if (typeof selector == 'string') {
      return (
        compareValues(a[selector as keyof T], b[selector as keyof T]) *
        orderSign
      );
    } else if (typeof selector == 'function') {
      return compareValues(selector(a), selector(b)) * orderSign;
    }
  });
}

function compareValues(a, b) {
  if (typeof a == 'string') {
    return String(a).localeCompare(String(b), undefined, {
      usage: 'sort',
      sensitivity: 'base',
    });
  } else {
    return a > b ? 1 : a < b ? -1 : 0;
  }
}
